import React, { useState } from 'react';
import { When } from 'UI/components/atoms/When';

import {
  ACTIVATION_KEYS,
  DEFAULT_TITLE_FIELD,
  HOVERED_COLOR_ALPHA_SUFFIX,
  MARKER_CENTER,
  MARKER_RADIUS,
  MARKER_SIZE
} from './MapGroupedMarker.constants';
import { buildPieSlices } from './MapGroupedMarker.utils';

/**
 * @typedef {Object} MapGroupedMarkerProps
 * @property {Function} [onClick]
 * @property {Function} [onMouseEnter]
 * @property {string} titleField
 * @property {*[]} groupedData
 */

/**
 * @param {MapGroupedMarkerProps} props
 */
const MapGroupedMarker = props => {
  const { onClick, onMouseEnter, titleField = DEFAULT_TITLE_FIELD, groupedData } = props;
  const [hovered, setHovered] = useState(undefined);

  const onMouseOverHandler = (_, propsData, index) => {
    setHovered(index);
    onMouseEnter && onMouseEnter(propsData[index]);
  };

  const onMouseOutHandler = () => {
    setHovered(undefined);
  };

  const onClickHandler = (event, propsData, index) => {
    onClick && onClick(propsData[index]);
  };

  const onKeyDownHandler = (event, propsData, index) => {
    if (!ACTIVATION_KEYS.includes(event.key)) return;
    event.preventDefault();
    onClickHandler(event, propsData, index);
  };

  const data = groupedData
    .map(item => ({ ...item, value: groupedData.length, title: item[titleField] }))
    .map((entry, i) => {
      if (hovered === i) {
        return {
          ...entry,
          color: `${entry.color}${HOVERED_COLOR_ALPHA_SUFFIX}`
        };
      }
      return entry;
    });

  const slices = buildPieSlices(data, {
    cx: MARKER_CENTER,
    cy: MARKER_CENTER,
    radius: MARKER_RADIUS
  });

  return (
    <div
      style={{
        width: MARKER_SIZE,
        height: MARKER_SIZE
      }}
    >
      <svg
        viewBox={`0 0 ${MARKER_SIZE} ${MARKER_SIZE}`}
        width="100%"
        height="100%"
        style={{ display: 'block' }}
      >
        {slices.map((slice, index) => (
          <path
            key={slice.key}
            d={slice.path}
            fill={slice.color}
            tabIndex={0}
            role="button"
            onClick={event => onClickHandler(event, data, index)}
            onKeyDown={event => onKeyDownHandler(event, data, index)}
            onMouseOver={event => onMouseOverHandler(event, data, index)}
            onMouseOut={onMouseOutHandler}
            onFocus={event => onMouseOverHandler(event, data, index)}
            onBlur={onMouseOutHandler}
          >
            <When condition={data[index].title}>
              <title>{data[index].title}</title>
            </When>
          </path>
        ))}
      </svg>
    </div>
  );
};

MapGroupedMarker.defaultProps = {
  onClick: undefined,
  onMouseEnter: undefined
};

export default MapGroupedMarker;
